const GOERLI_NETWORK_ID = 5;
const MAINNET_NETWORK_ID = 1;

export { GOERLI_NETWORK_ID, MAINNET_NETWORK_ID };
